import { forwardRef, useId, type InputHTMLAttributes } from 'react'
import { cn } from '@cannect/lib/utils'

type DateFieldProps = InputHTMLAttributes<HTMLInputElement> & { label: string; error?: string; hint?: string }

// Campo de data nativo (`YYYY-MM-DD`): teclado e calendário do sistema, sem fuso.
export const DateField = forwardRef<HTMLInputElement, DateFieldProps>(
  ({ label, error, hint, className, ...props }, ref) => {
    const id = useId()
    const hintId = `${id}-hint`
    const errorId = `${id}-error`

    return (
      <div className="flex flex-col gap-1">
        <label htmlFor={id} className="text-sm font-semibold text-neutral-800">
          {label}
        </label>
        <input
          ref={ref}
          id={id}
          type="date"
          aria-invalid={Boolean(error)}
          aria-describedby={cn(hint && hintId, error && errorId) || undefined}
          className={cn(
            'h-11 rounded-md border border-solid px-3 text-sm text-neutral-800',
            error ? 'border-red-700' : 'border-neutral-300',
            className
          )}
          {...props}
        />
        {hint && (
          <span id={hintId} className="text-xs text-neutral-600">
            {hint}
          </span>
        )}
        <span id={errorId} aria-live="polite" className="min-h-[1rem] text-xs text-red-700">
          {error}
        </span>
      </div>
    )
  }
)

DateField.displayName = 'DateField'
